import {Component, Input, OnInit} from '@angular/core';
import {CCPXDEVEVHI_HP} from "../complexDevices";

@Component({
  selector: 'app-cpxdev-evhi-hp',
  templateUrl: './cpxdev-evhi-hp.component.html',
  styleUrls: ['./cpxdev-evhi-hp.component.css']
})
export class CPXDEV_EVHI_HPComponent implements OnInit {
  @Input()  cCPXDEV_EVHI: CCPXDEVEVHI_HP | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
